import styled from '@emotion/styled';
import { Box } from "mesh-component-library";

const StyledBenefitsSection = styled(Box)`
  text-align: left;
  padding: 1rem 1rem 1rem 1rem;
  margin: 0.3571428571rem auto 1.4285714286rem auto;
  max-width: 640px;
  background-color: inherit !important;
  border: 1px solid #E1E6EB;
  width: 90%;

  .benefit-title{
    font-weight: 550;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 35px;
    letter-spacing: 0px;
    vertical-align: middle;
  }

  .benefit-description{
    font-weight: 400;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0px;
  }

  input[type="radio"] {
    align-self: center;
    margin-top: 0;
  }

  label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  input[type="radio"]:hover ~ * {
    background-color: transparent !important;
  }
`;

export default StyledBenefitsSection;